import { create } from "zustand";

export const useStepStore = create<{
  currentStep: number;
  forwrdStep: () => void;
  backwardStep: () => void;
}>((set) => ({
  currentStep: 0,
  forwrdStep: () =>
    set((state) => ({
      currentStep: state.currentStep + 1,
    })),
  backwardStep: () =>
    set((state) => ({
      currentStep: state.currentStep - 1,
    })),
}));
